module.exports = __webpack_public_path__ + "static/media/feedly-glass-ss.2694c976.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/feedly-glass-ss.png
 ** module id = 204
 ** module chunks = 0
 **/